import { ReplicaType } from "types";
import Version1 from "./version-1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "daily-prophet-hp2-flying-ford-anglia-mystifies-muggles",
  name: `The Evening Prophet\n'Flying Ford Anglia Mystifies Muggles'`,
  origin: "Harry Potter and the Chamber of Secrets",

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
